const CheckJim = (props) => {

    const { name, value, label, classN, error, onChange } = props

    const handleChange = (e, newValue) => {
        const { name, checked } = e.target
        onChange(name, checked)
    }
    return (
        <>

            <div className='check-container'>

                <label className={`label ${classN}`} htmlFor={name}>

                    {label}
                </label>
                <input
                    name={name}
                    type='checkbox'
                    className={error ? ' check errorfocus' : 'check'}
                    checked={value}
                    onChange={handleChange}
                />


            </div>

        </>
    )
}
export default CheckJim